const tr = {
  home: {
    biometric_label: "BİYOMETRİK KİMLİK DOĞRULAMA",
    title: "Yüz Ters Araması Artık Kolay",
    description:
      "Gelişmiş nöral eşleme kullanarak küresel dijital arşivlerle çapraz referans yapmak için yüksek çözünürlüklü bir portre yükleyin.",
    drag_drop: "Resminizi sürükleyip bırakın",
    file_formats: "RAW, JPEG veya PNG destekler (Maks. 15MB)",
    select_file: "SİSTEMDEN DOSYA SEÇ",
    initiate_scan: "Adli Taramayı Başlat",
    upload_hint: "DEVAM ETMEK İÇİN LÜTFEN BİR RESIM YÜKLEYİN",
    uploading: "Yükleniyor",
    searching: "Taranıyor",
    result_title: "Sonuçlar",
    drop_here: "Resmi buraya bırakın...",
    billion_faces: "İnternetteki 1 milyardan fazla yüzle karşılaştırın",
    login_to_search: "Aramak için giriş yapın",
    login_required:
      "Bu uygulamayı kullanmak için giriş yapın veya hesap oluşturun",
    not_enough_tokens: "Yeterli token yok",
    please_wait: "Lütfen birkaç dakika bekleyin",
    leave_confirmation:
      "Devam eden bir işlem var. Sayfadan ayrılmak istediğinizden emin misiniz?",
  },
  sources: {
    section_title: "Aradığımız Kaynaklar",
    social_media: {
      name: "Sosyal Medya",
      description: "Büyük sosyal ağlar ve genel profillerde çapraz referans.",
    },
    web: {
      name: "Web",
      description: "Kamuya açık yüz verileri için açık web'i tarar.",
    },
    scammers: {
      name: "Dolandırıcılar",
      description:
        "Bilinen dolandırıcı kimlik ve sahtecilik veritabanlarıyla eşleşir.",
    },
    sexual_offenders: {
      name: "Cinsel Suçlular",
      description: "Kamuya açık kayıtlı suçlu kayıtlarıyla çapraz referans.",
    },
    videos: {
      name: "Videolar",
      description:
        "Genel video platformlarından yüzleri çıkarır ve eşleştirir.",
    },
    police_photos: {
      name: "Polis Fotoğrafları",
      description: "Kamuya açık polis kayıt veritabanlarıyla karşılaştırır.",
    },
    news_and_blogs: {
      name: "Haberler & Bloglar",
      description: "Haber arşivlerini, editoryal içerikleri ve blogları arar.",
    },
  },
  header: {
    scan: "TARA",
    history: "GEÇMİŞ",
    pricing: "FİYATLAR",
    account: "HESAP",
    logout: "ÇIKIŞ YAP",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Tüm hakları saklıdır. Hassas Kimlik Doğrulama.",
    privacy: "Gizlilik Politikası",
    terms: "Hizmet Şartları",
    docs: "Belgeler",
    support: "Destek",
  },
  common: {
    loading: "Yükleniyor...",
    error: "Hata",
    cancel: "İptal",
    back: "Geri",
  },
  errors: {
    upload_failed: "Yükleme başarısız. Lütfen tekrar deneyin.",
    not_enough_tokens: "Bu aramayı gerçekleştirmek için yeterli tokenınız yok.",
  },
  login: {
    disclaimer:
      "Bu uygulamayı kullanmak için bir hesaba ihtiyacınız var. Spam göndermiyoruz ve e-postanızı paylaşmıyoruz. Gizliliğinizi korumak için Apple ile giriş yapmanızı öneririz.",
  },
  results: {
    input_source: "GİRİŞ KAYNAĞI",
    match_thumbnail: "Eşleşme küçük resmi",
    extraction_id: "ÇIKARMA KİMLİĞİ",
    scan_analysis: "Tarama Analizi",
    scan_description:
      "Biyometrik tersine arama tamamlandı. Herkese açık kayıtlarda ve sosyal dizinlerde %{count} olası eşleşme bulundu.",
    col_identity_map: "KİMLİK HARİTASI",
    col_verification_path: "DOĞRULAMA YOLU",
    col_bio_match_score: "BİYO EŞLEŞTİRME PUANI",
    col_action: "İŞLEM",
    export_pdf: "PDF Dışa Aktar",
    exporting: "Oluşturuluyor...",
    verified: "DOĞRULANDI",
    details: "DETAYLAR",
    details_tooltip: "Hassas yüz karşılaştırması çalıştır",
    details_loading: "Karşılaştırılıyor...",
    copied: "Kopyalandı!",
    copy_url: "URL Kopyala",
    displaying: "%{total} tespiten %{count} gösteriliyor",
  },
};

export default tr;
